import { auth } from './firebase';

// The exportEvidence Cloud Function (Stage 2). Download-only, role-gated,
// audited server-side; it streams bytes back â€” no public/shareable URL.
const EXPORT_FN_URL = 'https://europe-west2-o-ops-eu.cloudfunctions.net/exportEvidence';

// Firebase Storage download URLs look like:
//   https://firebasestorage.googleapis.com/v0/b/<bucket>/o/<URL-ENCODED-PATH>?alt=media&token=...
// The Cloud Function needs the raw object PATH (companies/<tenant>/...), so
// pull it back out of the display URL. Returns null if the URL isn't a
// recognisable Storage download URL (e.g. an external link).
export function storagePathFromUrl(url) {
  if (typeof url !== 'string') return null;
  const marker = '/o/';
  const i = url.indexOf(marker);
  if (i === -1 || !url.includes('firebasestorage.googleapis.com')) return null;
  const enc = url.slice(i + marker.length).split('?')[0];
  try { return decodeURIComponent(enc); } catch { return null; }
}

// Download one evidence file via the gated function. type: 'incident' |
// 'patrol_issue'; id: the record id; url: the stored display URL. Triggers a
// browser download on success. Throws Error(message) on failure so the caller
// can show a state.
export async function downloadEvidence({ type, id, url }) {
  const path = storagePathFromUrl(url);
  if (!path) throw new Error('Not an exportable Storage file');
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in');
  const token = await user.getIdToken();

  const res = await fetch(EXPORT_FN_URL, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, id, path }),
  });

  if (!res.ok) {
    let msg = `Export failed (${res.status})`;
    try { const j = await res.json(); if (j.error) msg = j.error; } catch { /* non-JSON */ }
    throw new Error(msg);
  }

  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objUrl;
  a.download = path.split('/').pop() || 'evidence';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke after a tick so the download has started.
  setTimeout(() => URL.revokeObjectURL(objUrl), 4000);
}
